import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

import { config } from '#config.ts';

export const browserAgent = new BrowserAgent(config.NEW_RELIC_AGENT_CONFIG);
